import {Component, OnDestroy} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {map, Observable, startWith, Subject} from 'rxjs';
import {Offer} from '../../../../../model/offer/offer';

@Component({
    selector: 'app-offer-form-base',
    template: '',
    standalone: false
})
export abstract class OfferFormBase implements OnDestroy {
  abstract formGroup: FormGroup;
  protected destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  validStatus(): Observable<boolean> {
    return this.formGroup.valueChanges.pipe(
      map(() => this.formGroup.valid), startWith(false));
  }

  abstract updateOffer(offer: Offer): void;

  abstract prefill(offer: Offer): void;
}
